import React from 'react';
import * as index from './image/index.js';

const RewardTypeIcon = ({
  type,
  customIconUrl,
  iconComponent,
  transform = {
    scale: 1,
    y: "-8px"
  },
  className,
  style
}) => {
  if (type) {
    const exist = index[type];
    if (exist) {
      return /* @__PURE__ */ React.createElement(
        "img",
        {
          src: exist,
          alt: "",
          className,
          style: {
            ...style,
            transform: `translateY(${transform.y}) scale(${transform.scale})`,
            objectFit: "none"
          }
        }
      );
    }
    if (customIconUrl) {
      return /* @__PURE__ */ React.createElement("img", { src: customIconUrl, alt: "", className, style });
    }
    if (iconComponent) {
      return iconComponent;
    }
  }
  if (iconComponent) {
    return iconComponent;
  }
  if (customIconUrl) {
    return /* @__PURE__ */ React.createElement("img", { src: customIconUrl, alt: "", className, style });
  }
  if (type) {
    return /* @__PURE__ */ React.createElement(
      "img",
      {
        src: index[type],
        alt: "",
        className,
        style
      }
    );
  }
  return null;
};
RewardTypeIcon.displayName = "RewardTypeIcon";

export { RewardTypeIcon };
//# sourceMappingURL=index.js.map
